import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { Box } from "@mui/material";

import { AppHeaderNavItem } from "./AppHeaderNavItem";

export interface INavItem {
  label: string;
  href: string;
  subItems: string[];
  isDummy?: boolean;
}

export function AppHeaderNav(): JSX.Element {
  const { t } = useTranslation();
  const navDataArr: INavItem[] = [
    {
      label: t("WEG:buttons.header.returnToWEG"),
      href: t("WEG:buttons.header.returnToWEG.url"),
      subItems: [],
    },
    {
      label: t("WEG:buttons.header.toProjectList"),
      href: "/",
      subItems: [],
    },
  ];

  const navItemElements = navDataArr.map((navItem, index) => {
    return (
      <AppHeaderNavItem
        navItem={navItem}
        key={navItem.label + index}
        index={index}
        active={navItem.label === "Productfinder"}
      />
    );
  });

  return (
    <Box display="flex" alignItems="center">
      {navItemElements}
    </Box>
  );
}
